export default __webpack_public_path__ + "static/media/stephanie_tommy-461_tn.ba7a924c.jpg";